import { CONFIG_TRUSTARC_DOMAIN } from '@src/config/env'
import { TelemetryIntegration } from '@src/telemetry/telemetry-events.types'

import { initializeScript } from '../provider-utils/initialize-script'

export let isTrustARCScriptLoading = true
export let resolveTrustArcInitialisePromise: (value: unknown) => void
export const initialiseTrustARCPromise = new Promise(resolve => {
  resolveTrustArcInitialisePromise = resolve // Store the resolver for later use
})

export const TRUSTARC_CONFIG: TelemetryIntegration = {
  config: {
    enabled: true,
    eventIdealTimeout: 1000,
  },
  initialize: async () => {
    await initializeScript({
      key: 'trustarc',
      domain: 'https://consent.trustarc.com',
      path: `/notice?domain=${CONFIG_TRUSTARC_DOMAIN}&c=teconsent&js=nj&noticeType=bb&gtm=1&country=us`,
      injectAt: 'beforeFirstScript',
      onLoad: () => {
        console.log('TrustArc script loaded')
        resolveTrustArcInitialisePromise(null)
        isTrustARCScriptLoading = false
      },
    })
  },
}
